var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import Card from 'react-bootstrap/Card';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Card, { className: "mb-4" },
                React.createElement(Card.Header, null, "Prices"),
                React.createElement(Card.Body, null,
                    React.createElement(Card.Text, null, "XXX"))));
    };
    return default_1;
}(React.Component));
export default default_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJpY2VzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiUHJpY2VzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUM7QUFDL0IsT0FBTyxJQUFJLE1BQU0sc0JBQXNCLENBQUM7QUFFeEM7SUFBNkIsNkJBQWU7SUFBNUM7O0lBZUEsQ0FBQztJQWRDLDBCQUFNLEdBQU47UUFDRSxPQUFPO1lBQ0wsb0JBQUMsSUFBSSxJQUFDLFNBQVMsRUFBQyxNQUFNO2dCQUNwQixvQkFBQyxJQUFJLENBQUMsTUFBTSxpQkFFRTtnQkFDZCxvQkFBQyxJQUFJLENBQUMsSUFBSTtvQkFDUixvQkFBQyxJQUFJLENBQUMsSUFBSSxjQUVFLENBQ0YsQ0FDUCxDQUNOLENBQUE7SUFDTCxDQUFDO0lBQ0gsZ0JBQUM7QUFBRCxDQUFDLEFBZkQsQ0FBNkIsS0FBSyxDQUFDLFNBQVMsR0FlM0MifQ==